import type { AppVariantConfig } from '@shared/app/variant';
import { en } from '@english/i18n/en';
import { nb } from '@oslo/i18n/nb';
import { InnovasjonNorgeApp } from './App';

export const innovasjonNorgeVariantConfig: AppVariantConfig = {
  variant: 'innovasjon-norge',
  locale: 'nb',
  messages: nb,
  fallbackMessages: en,
  themeClassName: 'theme-innovasjon-norge',
  AppContent: InnovasjonNorgeApp,
};
